import { useState, ReactNode } from 'react';
import { ReactComponent as VIcon } from '@elementary/common-ui/assets/v-green.svg';
import { Flex, Expandable } from '@elementary/common-ui/components';
import { Tooltip, Typography } from '@mui/material';

type Props = {
  children: ReactNode;
  isSuccess?: boolean;
};

const TestIntegrationSection = ({ children, isSuccess = false }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Expandable
      title={
        <Flex sx={{ gap: 1 }}>
          <Typography>Test connection</Typography>
          {isSuccess && (
            <Tooltip title="Connection test succeeded" placement="right">
              <Flex>
                <VIcon width={16} />
              </Flex>
            </Tooltip>
          )}
        </Flex>
      }
      expanded={isOpen}
      onChange={(_, val) => setIsOpen(val)}
    >
      {children}
    </Expandable>
  );
};

export default TestIntegrationSection;
